module.exports = __webpack_public_path__ + "img/vertical_3_3_8017.892c6db6.png";